module.exports = __webpack_public_path__ + "media/images/static/offer/lp_s04-1_s-aa8ba82e1df0de88172b18042a1b0788.png";